import axios from 'axios'

const authConfig = (access) => ({
  headers: { Authorization: `Bearer ${access}` },
})

export const exportDashboard = (code, access) => (
  axios.get(`/api/v1/dashboard/${code}/export/`, authConfig(access)).then(response => response.data)
)

export const importDashboard = (payload, access) => (
  axios({
    method: 'post',
    url: '/api/v1/dashboard/import/',
    data: payload,
    ...authConfig(access),
  }).then(response => response.data)
)
